import { UI_ELEMENT } from 'config/constants/ui'
import { createSelector } from 'reselect'

export const selectSplitSize = createSelector([
  state => state.userInterface.splitSize,
], splitSize => splitSize as { media: number })

export const selectIsResizingEditor = createSelector([
  state => state.userInterface.resizing,
], resizing => resizing as boolean)

export const selectElementDisplayType = createSelector([
  state => state.userInterface.elementDisplayType,
], elementDisplayType => elementDisplayType)

export const selectActiveInteractionUIElement = createSelector([
  state => state.userInterface.activeInteractionUIElement,
], activeInteractionUIElement => activeInteractionUIElement)

export const selectSourceAssetBounds = createSelector([
  state => state.userInterface.bounds[UI_ELEMENT.SOURCE_MEDIA_ASSET],
], bounds => bounds)
